
















// name, onDutyPhone, address
import { Component, Vue, Emit } from "vue-property-decorator";
import { auth, center as store } from "@/store/modules";

@Component({})
class CenterSelector extends Vue {
  get value() {
    return auth.currentCenterId;
  }

  get items() {
    return Object.values(store.items)
      .sort((a, b) => {
        if (!a.$isPrimary && b.$isPrimary) return 1;
        if (a.$isPrimary && !b.$isPrimary) return -1;
        return a.name.localeCompare(b.name);
      })
      .map(item => ({
        ...item,
        ...(item.$isPrimary ? {name: `⭐ ${item.name}`} : {})
      }));
  }

  change(value: string) {
    auth.changeCenter(value);
    this.onChange(value);
  }

  @Emit('change')
  onChange(value: string) { return value; }
}

export default CenterSelector;
